<template>
	<div class="page">
		<div class="login zl-login">
			<div class="loginTItle" :style="getHgt">
				<!-- <div class="logo"><img src="../assets/images/logo2.png" width="100%"></div> -->
				<h1>客户管理系统</h1>
				<!-- <p>Customer Management Platform</p> -->
			</div>
			<el-form :model="loginData" key="login" :rules="rules" ref="ruleForm" label-width="0px" class="login-container">
				<el-form-item prop="account">
					<el-input type="text" @keyup.native.enter="handleSubmit" v-model="loginData.username" placeholder="请输入账号"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input type="password" @keyup.native.enter="handleSubmit" v-model="loginData.password" placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-checkbox style="position:relative; top:-5px; margin-bottom:10px;" v-model="loginData.isAutoLogin">记住密码</el-checkbox>
				<el-form-item>
					<el-button type="primary" style="width:100%;" v-loading="bLoading" @click="handleSubmit">登录</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loginUrl:'/login',
                loginData:{
                    username: '',
                    password: '',
                    isAutoLogin: false,
                },
				rules: {
					username: [
						{ required: true, message: '请输入登录账号', trigger: 'blur' }
					],
					password: [
						{ required: true, message: '请输入登录密码', trigger: 'blur' }
					]
				},
				getHgt:{
					'height': document.documentElement.clientHeight / 2 - 50 + 'px'
				}
			}
		},
		methods: {
			handleSubmit() {
				this.request(this.loginUrl, this.loginData, (res)=>{
                    this.$message({ message:'登录成功' , type:'success' });
                    if(this.loginData.isAutoLogin){
                        localStorage.setItem('loginData', JSON.stringify(this.loginData));
					}
					sessionStorage.setItem('loginData', JSON.stringify(this.loginData));
                    this.toPage('count');
            	})
			},
		},
		created(){
			if(localStorage.getItem('loginData')){
                let loginData = JSON.parse(localStorage.getItem('loginData'));
                if(loginData.isAutoLogin){
                    this.loginData = this.mergeObject(this.loginData, loginData);
                }
            }
		}
	}
</script>
<style lang="less">
.zl-login { 
    .loginTItle{ position:relative; min-height:300px; color:#fff;text-align:center; text-shadow:0 1px 3px rgba(0,0,0,.4),0 0 30px rgba(0,0,0,.075); background:#015bcd; background:linear-gradient(45deg,#015bcd 0,#71afd6 100%);box-shadow:inset 0 3px 7px rgba(0,0,0,.2),inset 0 -3px 7px rgba(0,0,0,.2);
        h1 { position: absolute; top:50%; left:0; width:100%; font-size:48px; z-index: 2; letter-spacing:5px; transform: translateY(-70px); }
        p { position: absolute; top:50%; left:0; width:100%; font-size:22px; z-index: 2; transform: translateY(10px); }
        &:before { position: absolute; left:0; top:0; display:block; content:''; width:100%; height:100%; background:url(../assets/images/bg.png) repeat center; opacity:0.6; z-index: 1; }
		.logo { position: absolute; left:50%; top:50%; width:90px; transform: translate(-430px,-49%); }
	}
    .login-container { width:300px; margin:50px auto 0;
        .el-input input { padding-left:34px; height:40px; background:url(../assets/images/icon_admin.svg) no-repeat 5px center; background-size:24px 24px;
            &[type=password] { background:url(../assets/images/icon_psd.svg) no-repeat 5px center; background-size:24px 24px; }
        }
        button { height:40px; background:#015bcd; }
    }

    .footer { position:fixed; bottom:0; left:0; width:100%; text-align:center; }
}
</style>
